export const SELF_ONBOARDING_EMAIL_STORAGE_KEY = 'plg-self-onboarding-email';
export const SELF_ONBOARDING_TICKET_STORAGE_KEY = 'plg-self-onboarding-branding-ticket';
export const SELF_ONBOARDING_VERIFIED_TOKEN_STORAGE_KEY = 'plg-self-onboarding-verified-token';
export const SELF_ONBOARDING_FOUNDER_NAME_STORAGE_KEY = 'plg-self-onboarding-founder-name';
export const SELF_ONBOARDING_COMPANY_NAME_STORAGE_KEY = 'plg-self-onboarding-company-name';
export const SELF_ONBOARDING_DISPLAY_READY_STORAGE_KEY = 'plg-self-onboarding-display-ready';
/** In-progress signup step + non-password fields (refresh restore). */
export const SELF_ONBOARDING_SIGNUP_DRAFT_STORAGE_KEY = 'plg-self-onboarding-signup-draft';

/** Matches backend skip-branding default. */
export const SELF_ONBOARDING_DEFAULT_COLOR = '#4F46E5';

export const SELF_ONBOARDING_DEFAULT_LOGO_URL =
  'https://kincode-prod.s3.eu-central-1.amazonaws.com/PH_Wordmark-Blue_.png';

/**
 * Bootstrapped public campaign slug (`default`) — same as backend
 * `DEFAULT_SELF_ONBOARDING_CAMPAIGN_SLUG`. Used when restarting signup without a campaign in the URL.
 */
export const SELF_ONBOARDING_DEFAULT_CAMPAIGN_SLUG = 'default';

/**
 * Public signup URL with a campaign query. Falls back to the default campaign slug.
 */
export function buildSelfOnboardingSignupUrl(
  baseUrl: string,
  campaignSlug?: string | null
): string {
  const base = String(baseUrl || '').replace(/\?.*$/, '').replace(/\/?$/, '/');
  const slug =
    typeof campaignSlug === 'string' && campaignSlug.trim()
      ? campaignSlug.trim().toLowerCase()
      : SELF_ONBOARDING_DEFAULT_CAMPAIGN_SLUG;
  return `${base}?campaign=${encodeURIComponent(slug)}`;
}

export const EMAIL_REGEXP = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
export const HEX_COLOR_REGEXP = /^#[0-9A-Fa-f]{6}$/;
export const HTTPS_URL_REGEXP = /^https?:\/\/.+/i;
